require("-!/tmp/build_e52bb9a7/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/tmp/build_e52bb9a7/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/tmp/build_e52bb9a7/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 919
// module chunks = 0